import { render, staticRenderFns } from "./Pinchzoom.vue?vue&type=template&id=3ab5f13e&"
import script from "./Pinchzoom.vue?vue&type=script&lang=js&"
export * from "./Pinchzoom.vue?vue&type=script&lang=js&"
import style0 from "./Pinchzoom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports